<template>
    <h3 class="gmf-header" v-if="computedTitle" v-html="computedTitle" />
    <p class="gmf-comment-guidelines-content" v-if="computedContent" v-html="computedContent" />
</template>

<script>
import state from '@/state';
import md from '@/utils/md';

const t = state.t;

export default {
    props: {
        title: {
            type: String,
            default: null,
        },
        content: {
            type: String,
            default: null,
        }
    },
    data () {
        return {
            overridePhrases: {
                title: this.title,
                content: this.content,
            },
        };
    },
    methods: {
        setOverridePhrases (phrases) {
            this.overridePhrases = phrases;
        },
    },
    computed: {
        computedTitle () {
            const phrase = this.overridePhrases.title || this.title;
            if (! phrase) {
                return null;
            }
            const translation = t(phrase);
            if (! translation) {
                return null;
            }
            return translation;
        },
        computedContent () {
            const phrase = this.overridePhrases.content || this.content;
            if (! phrase) {
                return null;
            }

            const translation = t(phrase);
            if (! translation) {
                return null;
            }

            return md(translation.replaceAll('\\n', '\n'));
        },
    },
};
</script>